import { render, staticRenderFns } from "./TaskAdd.vue?vue&type=template&id=f3ddc166&scoped=true"
import script from "./TaskAdd.vue?vue&type=script&lang=js"
export * from "./TaskAdd.vue?vue&type=script&lang=js"
import style0 from "./TaskAdd.vue?vue&type=style&index=0&id=f3ddc166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ddc166",
  null
  
)

export default component.exports